import axios from 'axios'
import { ref } from 'vue'

const securityDevices = ref([])
const securityDevicesCategories = ref([])
const securityDevicesGrouped = ref([])
const loading = ref(false)

export default function useSecurityDevices() {
  const listCategories = () => {
    loading.value = true

    axios
      .get(`/api/action-plan/security-devices/categories/all`)
      .then((response) => {
        securityDevicesCategories.value = response.data
      })
      .catch((error) => {
        console.log({ error })
      })
      .finally(() => (loading.value = false))
  }

  const listDevices = () => {
    loading.value = true

    axios
      .get(`/api/action-plan/security-devices/devices/all`)
      .then((response) => {
        securityDevices.value = response.data
      })
      .catch((error) => {
        console.log({ error })
      })
      .finally(() => (loading.value = false))
  }

  const listDevicesGrouped = () => {
    loading.value = true

    axios
      .get(`/api/action-plan/security-devices/devices/all-grouped`)
      .then((response) => {
        securityDevicesGrouped.value = response.data
      })
      .catch((error) => {
        console.log({ error })
      })
      .finally(() => (loading.value = false))
  }

  const getDevice = (securityDeviceId) => {
    return new Promise((resolve, reject) => {
      loading.value = true

      axios
        .get(`/api/action-plan/security-devices/${securityDeviceId}/get`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log({ error })
          reject(error)
        })
        .finally(() => (loading.value = false))
    })
  }

  return {
    listCategories,
    listDevices,
    listDevicesGrouped,
    getDevice,
    securityDevices,
    securityDevicesCategories,
    securityDevicesGrouped,
    loading,
  }
}
